import {Component, Input, OnInit} from '@angular/core';

import {MenuService, ZonesService} from "../../core";
import {ZonesTileData} from "../../models";

@Component({
    selector: 'zones-tile',
    templateUrl: './zones-tile.component.html',
    styleUrls: ['./zones-tile.component.scss']
})
export class ZonesTileComponent implements OnInit {
    @Input() tile: ZonesTileData;

    constructor(
        private menu: MenuService,
        private zones: ZonesService,
    ) {
    }

    ngOnInit() {
        if (!this.tile.isSystemTile) {
            this.zones.clearValveDropdown();
        }
        if (this.tile.type === 252
            || this.tile.type === 24
            || this.tile.type === 'additionalContact'
            || this.tile.type === 251
        ) {
            /* zones.goToMenu needs some submenu element id
            to correctly set itself factory.parent for these types of tile */
            this.setSubmenuElementId();
        }
        if (this.zones.currentlyOpenDropdown === 'valve'
            || this.zones.currentlyOpenDropdown === 'opentherm'
            || this.zones.currentlyOpenDropdown === 'additionalContact'
        ) {
            if (!this.tile.isSystemTile) {
                this.zones.showHideDropdownList(this.zones.currentlyOpenDropdown);
            }
        }
    }

    setSubmenuElementId() {
        this.menu.getElementMenu(this.tile.menuId); // menu element for tile
        this.menu.getMenuChildElement(this.menu.elementMenu) // set menu.submenu
        if (this.menu.submenu[0]) {
            this.tile.submenuElementId = this.menu.submenu[0].id;
        }
    }
}
